export default "/images/topdanmark-min.avif?ca25591016145285af4e5741ee0c850f";